import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { GuestPrivilegeDTOBase } from "./GuestPrivilegeDTOBase";
import type { MembershipStaff } from "./MembershipStaff";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedBase } from "./TrackedBase";

export class GuestPrivilegeStaff implements GuestPrivilegeDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly membershipId: MembershipStaff | null, public readonly price: number | null, public readonly purchaseDate: Date | null, public readonly startDate: Date | null, public readonly purchasableState: PurchasableState, public readonly voidCloseId: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.membershipIdLoaded = this.membershipId != null;
    this.membershipIdCached = this.membershipId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private membershipIdLoaded: boolean;
  private membershipIdCached: MembershipStaff | null;
  async membershipIdLazy(): Promise<MembershipStaff> {
    if (!this.membershipIdLoaded) {
      this.membershipIdCached = await this.cbiServiceContext!.guestPrivilegeService().getGuestPrivilegeStaffMembershipId(this.assignId);
      this.membershipIdLoaded = true;
    }
    return this.membershipIdCached!;
  }
}
